<template>
  <div class="notification-user-search">
    <div class="list-page__querybar">
      <el-row :gutter="20">
        <el-col :span="2">用户筛选条件：</el-col>
        <el-col :span="10">
          <el-input
            v-model="queryCondition.keyWord"
            clearable
            placeholder="用户账号/手机号"
          >
          </el-input>
        </el-col>
        <el-col :span="10">
          <el-date-picker
            v-model="queryCondition.publishDate"
            type="daterange"
            :unlink-panels="true"
            start-placeholder="用户注册开始时间"
            end-placeholder="用户注册结束时间"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-col>
        <el-col class="fn-text-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div
      class="list-page__table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <el-table
        :data="queryList"
        @selection-change="handleSelectionChange"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="selection" width="40"> </el-table-column>

        <el-table-column
          prop="account"
          label="用户名"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="phoneNumber"
          label="手机号"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="userTypeName"
          label="认证类型"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column label="注册时间" width="90" align="center">
          <template slot-scope="scope">
            <p>
              {{ scope.row.createTime.trim().split(/\s+/)[0] }}
            </p>
            <!-- <p>
                {{ scope.row.createTime.trim().split(/\s+/)[1] }}
              </p> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "notificationUserSearch",
  props: {
    multipleSelection: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      //查询条件
      queryCondition: {
        publishDate: [],
        keyWord: "",
        pageIndex: 1,
        pageSize: 10
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: []
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    //出来参数
    processParams() {
      let { keyWord, pageIndex, pageSize, publishDate } = this.queryCondition,
        [createBegin = "", createEnd = ""] = publishDate || [];
      return {
        keyWord,
        pageIndex,
        pageSize,
        createBegin,
        createEnd
      };
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api("user", "getNotificationUserList", this.processParams()).then(
        (res) => {
          this.isLoading = false;
          this.total = res.count;
          this.queryList = res.dataList;
        }
      );
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    //表格相关
    //点击选中/取消选中表格选择项
    handleSelectionChange(selection) {
      this.$emit("update:multipleSelection", selection);
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  }
};
</script>

<style lang="less" scoped>
.notification-user-search {
  .list-page__querybar {
    padding: 0;
    margin: 0;
  }
  .list-page__table {
    padding: 20px 0 0;
  }
}
</style>
